let config = require('../core/environmentConfig');

function getNuDataApiKeys() {
     return config.nuData;
}

function getSessionId() {
    var ndClientId = getNuDataApiKeys();
    if (ndClientId) {
        return getNuDataApiKeys() ? document.querySelector('input[name="ndsid"]').value : "";
    }
}

function getWidgetData() {
    var ndClientId = getNuDataApiKeys();
    if (ndClientId) {
        return getNuDataApiKeys() ? document.querySelector('input[name="nds-pmd"]').value : "";
    }
}

function deleteNuDetectTraces() {
    var ndClientId = getNuDataApiKeys();
    if (ndClientId) {
        if (window.ndsapi) {
            var nds = window.ndsapi;

            if (nds.stop) {
                nds.stop();
            }

            document.querySelector('input[name="nds-pmd"]').value = "";
            document.querySelector('input[name="ndsid"]').value = "";
        }
    }
}

function includeNuDetectCalls() {
    var ndClientId = getNuDataApiKeys();
    if (ndClientId) {
        var baseUrl = "https://api-ob.nd.nudatasecurity.com/2.2/w/" + ndClientId + "/sync/js/";
        (function(w,d,s,u,q,js,fjs,nds){
        nds=w.ndsapi||(w.ndsapi={});
        nds.config={q:[],ready:function(cb){this.q.push(cb)}};
        js=d.createElement(s);fjs=d.getElementsByTagName(s)[0];js.src=u;
        fjs.parentNode.insertBefore(js,fjs);js.onload=function(){nds.load(u);}
        }(window,document,"script",baseUrl));
        var nds = window.ndsapi;
        nds.config.ready(function() {
            nds.setPlacement("Login");
        });
    }
}

function bindNewFields() {
    var ndClientId = getNuDataApiKeys();
    if (ndClientId) {
        if (window.ndsapi.bindNewFields) {
            var nds = window.ndsapi;
            nds.bindNewFields();
        }
    }
}

module.exports = {
    includeNuDetectCalls,
    getNuDataApiKeys,
    deleteNuDetectTraces,
    getSessionId,
    bindNewFields,
    getWidgetData
}
